import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import PropTypes from 'prop-types';
import TextField from 'material-ui/TextField';

const styles = (theme) => {
  const {
    custom: {
      palette: { colorSupportSlate },
    },
  } = theme;

  return {
    input: {
      '&::-ms-clear': {
        display: 'none',
      },
      '&::-ms-reveal': {
        display: 'none',
      },
      '& input::-ms-clear': {
        display: 'none',
      },
      '& ::-ms-clear': {
        display: 'none',
      },
      '& ::-ms-reveal': {
        display: 'none',
      },
      '&:invalid': {
        boxShadow: 'none',
      },
      '&:-moz-submit-invalid': {
        boxShadow: 'none',
      },
      '&:-moz-ui-invalid': {
        boxShadow: 'none',
      },
      '& :invalid': {
        boxShadow: 'none',
      },
      '& :-moz-submit-invalid': {
        boxShadow: 'none',
      },
      '& :-moz-ui-invalid': {
        boxShadow: 'none',
      },
      '& input': {
        fontWeight: '500 !important',
      },
      '& textarea': {
        fontWeight: '500 !important',
      },
      '& password': {
        fontWeight: '500 !important',
      },
      '& label': {
        fontWeight: '500 !important',
        color: colorSupportSlate,
      },
    },
  };
};

const TextFieldStyled = ({ classes, ...props }) => <TextField className={classes.input} {...props} />;

TextFieldStyled.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(TextFieldStyled);
